import React, { useState } from "react";
import Chat from "./Chat";
import { Modal } from "antd-mobile";
import modalStyl from './ChatModel.module.scss'
import storageX from "../../utils/storageX";


type Props = {
  fromDoctor?: boolean;
  createUserCode?: string;
  subjectCode: string;
  onClose: () => void;
}

const ChatModal:React.FC<Props> = ({ fromDoctor = true, subjectCode, createUserCode = '', onClose }) => {
  const [readonly] = useState(()=> {
    // 患者不需要禁用
    if (false === fromDoctor) {
      return false
    }
    return storageX().user().userCode !== createUserCode
  });

  const [className] = useState(()=> {
    const classList = [modalStyl.modal]
    if(window.navigator.userAgent.indexOf('MicroMessenger') > -1) {
      classList.push(modalStyl.microMessenger)
    }
    return classList.join(' ')
  })

  return (
    <Modal
      className={className}
      wrapClassName={modalStyl.wrapper}
      visible={true}
      onClose={onClose}
    >
      <Chat readonly={readonly} fromDoctor={fromDoctor} createUserCode={createUserCode} subjectCode={subjectCode}/>
    </Modal>
  );
};

export default ChatModal;
